import { AboType } from '../enums/abo-type';

export class DashMicrositeMatchQuality {
    public micrositeAbo?: AboType;
    public registrationAbo?: AboType;
    public drMismatch?: number;
    public dqMismatch?: number;
    public dqMismatchLow?: number;
    public alleleMatchOf8?: number;
}